/**
 * SETTING_POOL
 *
 * Hand-authored noun phrases used as per-phase setting descriptors.
 * Three are drawn without replacement at game start (one per phase).
 */
export const SETTING_POOL: readonly string[] = [
	"abandoned subway station",
	"sun-baked salt flat",
	"forgotten laboratory",
	"moonlit greenhouse ruin",
	"stripped server vault",
	"tide-flooded boardwalk",
	"humid and dense bog",
	"library overflowing with books",
	"throne room of a pagoda",
	"dust-filled opera hall",
	"collapsed market arcade",
	"hollowed glacier cave",
	"flooded underground cistern",
	"silent planetarium dome",
	"rusted oil platform deck",
	"ink-stained printing hall",
] as const;
